module.exports = __webpack_public_path__ + "img/cancelled-downArrow.5340ef12.svg";